import React, { createContext, useContext, useState } from 'react';

const ParamContext = createContext();

export const useParam = () => useContext(ParamContext);

export const ParamProvider = ({ children }) => {
  const [param, setParam] = useState('');

  return (
    <ParamContext.Provider value={{ param, setParam }}>
      {children}
    </ParamContext.Provider>
  );
};